import Vue from 'vue'
import { axios } from '@/axios/http'
import common from '@/util/common'

// post
export function postAction (url, parameter) {
  return axios({
    url: url,
    method: 'post',
    data: parameter
  })
}

// post method= {post | put}
export function httpAction (url, method, parameter) {
  let str = common.getAppCode()
  const base = {
    version: '123456',
    appCode: str, // 0: 散   1: 团
    parkId: '1',
    parkCode: 'YHYPARK',
    userId: '1'
    // userId: '1590631966945713517'
  }
  let obj = {}
  obj = Object.assign(base, parameter)
  return axios({
    url: url,
    method: method,
    data: obj
  })
}

// put
export function putAction (url, parameter) {
  return axios({
    url: url,
    method: 'put',
    data: parameter
  })
}

// get
export function getAction (url, parameter) {
  return axios({
    url: url,
    method: 'get',
    params: parameter
  })
}

// deleteAction
export function deleteAction (url, parameter) {
  return axios({
    url: url,
    method: 'delete',
    params: parameter
  })
}
